import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c770e25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tags" }

import { useStore } from 'vuex'
import Tag from '@/components/atoms/Tag'
import APP from '@/js/const/app'
import { computed } from 'vue'
import { CameratagWithCameras } from '@/@types/typescript-axios'

type FuncType = {
  name: string
  value: string
}
type RouteQueryType = {
  filter: string[]
  tags: string[]
  func: string[]
  watch_status?: string
}

type PropsType = {
  routeQuery: RouteQueryType
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchConditions',
  props: {
    routeQuery: null
  },
  emits: ["updateDownQuery", "unsetQueryParams"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateDownQuery', status: string): void
  (e: 'unsetQueryParams', type: string, value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  routeQuery: RouteQueryType
};

const store = useStore()





const keyword = computed<string | string[]>(() => props.routeQuery.filter)
const tags = computed(() => {
  return store.getters['tag/tags'].filter((d: CameratagWithCameras) => {
    return props.routeQuery.tags.find((st: string) => d.tag_code === st)
  })
})

const func = computed(() => {
  const func = APP.FUNC(store.getters['app/settings'].environmentMode)
  return func.filter((d: FuncType) => {
    return props.routeQuery.func.find((sf: string) => d.value === sf)
  })
})

const downCamera = computed<boolean>(() => props.routeQuery.watch_status === 'down')

/**
 * 検索フィルタを削除
 * @param {String} type 削除する対象「キーワード、タグ、機能」のいずれか
 * @param {String} value 削除する値(タグ、機能のみ利用)
 */
const remove = (type: string, value: string) => {
  emit('unsetQueryParams', type, value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyword), (k, index) => {
      return (_openBlock(), _createBlock(_unref(Tag), {
        key: index,
        text: k,
        "use-remove-btn": true,
        onClick: ($event: any) => (remove('keyword', k))
      }, null, 8, ["text", "onClick"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (tag) => {
      return (_openBlock(), _createBlock(_unref(Tag), {
        key: tag.tag_code,
        text: tag.tag_name,
        "use-remove-btn": true,
        onClick: ($event: any) => (remove('tag', tag.tag_code))
      }, null, 8, ["text", "onClick"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(func), (f) => {
      return (_openBlock(), _createBlock(_unref(Tag), {
        key: f.value,
        text: f.name,
        "use-remove-btn": true,
        onClick: ($event: any) => (remove('func', f.value))
      }, null, 8, ["text", "onClick"]))
    }), 128)),
    (_unref(downCamera))
      ? (_openBlock(), _createBlock(_unref(Tag), {
          key: 0,
          text: _ctx.$t('search_conditions.down'),
          tagColor: "red",
          useRemoveBtn: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updateDownQuery', '')))
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})